import { render } from "./assessment-panel-mobile.vue?vue&type=template&id=c0db1c6a&scoped=true&ts=true"
import script from "./assessment-panel-mobile.vue?vue&type=script&lang=ts"
export * from "./assessment-panel-mobile.vue?vue&type=script&lang=ts"

import "./assessment-panel-mobile.vue?vue&type=style&index=0&id=c0db1c6a&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c0db1c6a"]])

export default __exports__